import { AxiosPromise } from 'axios'
import client from '@/shared/apis/client'
import type { GuidanceApiResponse } from '../../shared/types'
import type { FinishAuditRequest, FinishAuditResponse } from '../types'

// V3 専用 envelope 取得. back: GET /api/v3/guidance/<id>/
// version=='v2' の guidance_data があれば 409 mismatch を返す (= front 側で catch).
export const getGuidanceV3 = (
  yakurekiId: string
): AxiosPromise<GuidanceApiResponse> => {
  return client.get(`/api/v3/guidance/${yakurekiId}/`)
}

// 監査を終える. back: POST /api/v3/guidance/<id>/audit/
// 申し送りが空でなければ、 次の GET で確認要点が作り直される (= status が processing に戻る).
// もう一度押せば上書き.
export const postGuidanceAuditV3 = (
  yakurekiId: string,
  body: FinishAuditRequest
): AxiosPromise<FinishAuditResponse> => {
  return client.post(`/api/v3/guidance/${yakurekiId}/audit/`, body)
}
